import React from 'react';
import {graphql} from 'gatsby';
import ArtPieceModal from './ArtPieceModal';
import ImageGrid from './ImageGrid';
import {getCaptionFromPictureMeta} from '../helpers';

const ArtPieceGallery = ({images, meta}) => (
    <ImageGrid
        images={images}
        renderModal={({index, close, next, prev}) => (
            <ArtPieceModal
                onRequestClose={close}
                onRequestNext={next}
                onRequestPrev={prev}
                image={images[index].full}
                meta={meta[index]}
            />
        )}
        renderOverlay={({index}) => (
            <span>{getCaptionFromPictureMeta(meta[index])}</span>
        )}
    />
);

export default ArtPieceGallery;

export const query = graphql`
fragment ArtPieceMetadata on ContentfulPiece {
  id
  height
  width
  year
  title
}
`;
